import {
    NinchatCheckIconSolid,
    NinchatReturnIcon,
} from '../Icon'
import React from 'react'
import {
    TagProps,
} from './types'

import {checkIcon} from './styles'
import {styled} from '../../stitches/config'
import {useTranslation} from 'react-i18next'

const StyledIcon = styled('div', {
    alignItems: 'center',
    color: '$tagIcon',
    display: 'inline-flex',
    filter: 'flipv',
    margin: '0 5px',
    transform: 'rotate(180deg) scaleY(-1)',
    width: '0.8rem',
})

const StyledTag = styled('div', {
    backgroundColor: '$tagBackground',
    border: '1px solid $tagBorder',
    borderLeftWidth: '8px',
    borderRadius: '$tagBorder',
    color: '$tagText',
    display: 'inline-flex',
    fontSize: '$tagText',
    padding: '$tagPaddingVertical $tagPaddingHorizontal',
    variants: {
        noLeftBorder: {true: {borderLeftWidth: '1px'}},
        selected: {
            true: {
                backgroundColor: '$tagBackgroundSelected',
                borderColor: '$tagBorderSelected',
                color: '$tagTextSelected',
                paddingRight: '5px',
            },
        },
        showParent: {true: {color: '$tagText'}},
    },
})

const StyledCheckIcon = styled('div', checkIcon)

const TagView = (props: TagProps): React.ReactElement => {
    const {
        parentName,
        tag_attrs,
        selected,
        showParent,
        showTheme,
        noLeftBorder,
    } = props

    const {t} = useTranslation()

    return (
        <StyledTag
            noLeftBorder={noLeftBorder}
            selected={selected}
            showParent={showParent}
            style={showTheme && !selected && tag_attrs?.theme?.color ? {borderColor: tag_attrs.theme.color} : {}}
        >
            {!!showParent && !!parentName &&
                <>
                    {parentName}<StyledIcon><NinchatReturnIcon /></StyledIcon>
                </>}
            {tag_attrs?.name || t('Unnamed')}
            {selected ? <StyledCheckIcon><NinchatCheckIconSolid /></StyledCheckIcon> : ''}
        </StyledTag>
    )
}

TagView.defaultProps = {
    parentName: undefined,
    showParent: false,
    showTheme: true,
}

export default TagView
